(ns iris.core
  (:require
   ["react-dom/client" :refer [createRoot]]
   [reagent.core :as r]
  ;;  [reagent.dom :as rdom]
   [goog.dom :as gdom]
   [re-frame.core :as re-frame]
   [day8.re-frame.http-fx]
   [cljs.core.async :refer [<! >! go chan put! alts! go-loop timeout]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [iris.config :as config]


   [iris.fingerprint] ; Side-effect: starts fingerprint collection

   [iris.auth.api :as auth]
   [iris.globals :as globals]
   [iris.utils :as utils]
   [goog.functions]
   [goog.dom.ViewportSizeMonitor]
   [goog.userAgent]
   [goog.events]
   [clojure.string :as string]
   [iris.anchor-scroll :as anchor-scroll]
   [iris.route-scroll :as route-scroll]
   [iris.routes :as routes]
   [iris.events :as events]
   [iris.route-data.events]
   [iris.views :as views]

   [iris.localstorage :as localstorage]

   [iris.indexeddb :as idb]

   [iris.posts.events :as posts-events]

   [iris.login.events :as login-events]

   
   [iris.firebase :as firebase]))







(defn dev-setup []
  (when config/debug?
    (println "dev mode")))



;; (defonce root (createRoot (gdom/getElement "app")))

(defn ^:dev/after-load mount-root []
  (re-frame/clear-subscription-cache!)
  ;; (let [root-el (.getElementById js/document "app")]
    ;; (rdom/unmount-component-at-node root-el)
    ;; (rdom/render [views/main-panel] root-el)
    (let [root (createRoot (gdom/getElement "app"))]
      (.render root (r/as-element [views/main-panel])))

    ;; )
  )


(defn set-mobile [m]
  (re-frame/dispatch [::events/set-mobile m]))

(defn set-viewport-size [d]
  (let [w (aget d "width")
        h (aget d "height")]
    (re-frame/dispatch [::events/set-viewport-size w h])))

(defn is-mobile? []
  (or goog.userAgent.MOBILE (utils/iOS13+iPad)))

(defn attach-viewport-size-monitor []
  (set-mobile (is-mobile?))
  (let [vsm (goog.dom.ViewportSizeMonitor.)]
    (set-viewport-size (.getSize vsm))
    (.listen goog.events vsm goog.events.EventType.RESIZE
             (goog.functions/debounce #(set-viewport-size (.getSize vsm)) 1000))))

(defn attach-scroll-event-listener []
  ;; TODO: check if google closure lib has scroll event
  ;; also make sure it's not attached multiple times
  (let [set-scroll-top #(re-frame/dispatch [::events/set-scroll-top (.-pageYOffset js/window)])]
    (set-scroll-top)
    (.addEventListener
     js/window
     "scroll"
     (goog.functions/throttle set-scroll-top 250)
     #js {:passive true})))


(defn sync-raid-len []
  (if-let [raid-len (localstorage/get-item "iris.post.raid-len")]
    (re-frame/dispatch [::events/set-raid-len (int raid-len)])
    (do
      (re-frame/dispatch [::events/set-raid-len globals/RAID_LEN_DEFAULT])
      (localstorage/set-item! "iris.post.raid-len" globals/RAID_LEN_DEFAULT))))

(defn sync-text-resizer []
  (if-let [font-size (localstorage/get-item "iris.post.font-size")]
    (re-frame/dispatch [::posts-events/set-font-size (int font-size)])
    (do
      (re-frame/dispatch [::posts-events/set-font-size globals/FONT_SIZE_DEFAULT])
      (localstorage/set-item! "iris.post.font-size" globals/FONT_SIZE_DEFAULT))))

(defn sync-theme []
  (let [theme (keyword (or (localstorage/get-item events/theme-storage-key) "light"))]
    (re-frame/dispatch-sync [::events/set-theme (events/valid-theme theme)])))

(defn sync-dark-theme-depth []
  (let [depth (or (localstorage/get-item events/dark-theme-depth-storage-key) "0")]
    (re-frame/dispatch-sync [::events/set-dark-theme-depth (events/valid-dark-theme-depth depth)])))


;; (defn ^:dev/after-load mount-root []
;;   (re-frame/clear-subscription-cache!)
;;   (let [root-el (.getElementById js/document "app")]
;;     (rdom/unmount-component-at-node root-el)
;;     (rdom/render [views/main-panel] root-el)))



(defn event-target-element [e]
  (let [target (.-target e)]
    (cond
      (nil? target) nil
      (= 1 (.-nodeType target)) target
      (.-parentElement target) (.-parentElement target)
      :else nil)))

(defn closest-anchor [el]
  (when (and el (.-closest el))
    (.closest el "a")))

(defn normal-primary-click? [e]
  (and (not (.-defaultPrevented e))
       (= 0 (or (.-button e) 0))
       (not (or (.-altKey e)
                (.-ctrlKey e)
                (.-metaKey e)
                (.-shiftKey e)))))

(defn href-current-path? [href]
  (let [url (js/URL. href (.. js/window -location -href))]
    (and (= (.-origin url)
            (.. js/window -location -origin))
         (= (.-pathname url)
            (.. js/window -location -pathname)))))

(defn intercept-click-event [e]
  (when (normal-primary-click? e)
    (when-let [anchor-el (closest-anchor (event-target-element e))]
      (when-let [href (.getAttribute anchor-el "href")]
        (let [hash (anchor-scroll/href-anchor href)]
          (when (and (some? hash)
                     (href-current-path? href))
            (let [loc-hash (-> (.. js/window -location -hash)
                               (.substring 1))]
              (when (= hash loc-hash)
                (.preventDefault e)
                (.replaceState js/history (.-state js/history) nil " ")
                (set! (.. js/window -location -hash) hash))
              (anchor-scroll/scroll-to-anchor! hash))))))))


;; ;; https://clojureverse.org/t/how-to-replace-cljs-http-client-get-with-js-fetch/9490
;; (defn fetch-post [ruid]
;;   (let [jwt @globals/jwt]
;;     (js/fetch js/apolloURL
;;               (clj->js {:method "POST"
;;                         :headers {:authorization (str "Bearer " jwt)
;;                                   :content-type "application/json"}
;;                         :body (js/JSON.stringify (clj->js {:jsonrpc "2.0"
;;                                                            :id 0
;;                                                                                       ;; :method "Post.Get"
;;                                                            :method "Post2a.Get"
;;                                                            :params {:options {:debug false}
;;                                                                     :data {:ruid ruid
;;                                                                            :include_screening_status false}}}))}))))
;; TODO: refactor or use more specific function name
;; intercepts <a> tag mouseover events for .ref.pref (post id references),
;; extracts ids/ruid from href, fetches the post and caches it to indexeddb for use in local state
;; where it is saved as a nested map with the post article id (paruid) containing nested ref ids (ruid)
(defn intercept-mouseover-event [e]
  (let [target (.-target e)]
    (when (= (.-tagName target) "A")
      (when (true? (-> target
                       (.matches ".ref.pref")))
        (posts-events/load-post-ref-from-a-pref-mouseover-event target)))))





(def touch-event (atom nil))
(def touchstart-ch (chan))
(def touchend-ch (chan))
(def touchcancel-ch (chan))

(defn intercept-touchstart-event [e]
   (put! touchstart-ch e))

(defn intercept-touchend-event [e]
  (put! touchend-ch e))

(defn intercept-touchcancel-event [e]
  (put! touchcancel-ch e))

(defn intercept-long-touch-event [e]
  (intercept-mouseover-event (.-detail e)))


(defn attach-long-touch-event-listener []
  (.addEventListener js/document "touchstart" intercept-touchstart-event)
  (.addEventListener js/document "touchend" intercept-touchend-event)
  (.addEventListener js/document "touchcancel" intercept-touchcancel-event)

  (.addEventListener js/document "long-touch-event" intercept-long-touch-event)

  (go-loop []
    (let [[key ch] (alts! [touchstart-ch
                           touchend-ch
                           touchcancel-ch
                           (timeout 500)])]
      (condp = ch
        touchstart-ch (do
                        (reset! touch-event key))
        touchend-ch (do
                      (when (nil? @touch-event)
                        (println "PREVENTING DEFAULT ON touchend-ch (need to uncomment)")
                    ;; (.preventDefault key)
                    ;; (.stopPropagation key)
                        )
                      (reset! touch-event nil))
        touchcancel-ch (do
                          ;;  (reset! touch-event nil)
                         )
        (do
          (when-not (nil? @touch-event)
              ;; (.preventDefault @touch-event)
              ;; (.stopPropagation @touch-event)
            (.dispatchEvent
             js/document
             (new js/CustomEvent "long-touch-event" #js {:bubbles true, :composed true :detail @touch-event}))
            (reset! touch-event nil)))))
    (recur)))




(defn init []
  
;; ;; (when-let [channel globals/fb-broadcast-channel]
;;   (set! (.-onmessage globals/fb-broadcast-channel)
;;         (fn [event]
;;           (println "Received message:" (.-data event))))
;;   ;; )


  (route-scroll/initialize!)

  (.addEventListener js/document "click" intercept-click-event)

  (if (is-mobile?)
    (attach-long-touch-event-listener)
    (.addEventListener js/document "mouseover" intercept-mouseover-event))


  ;; (.addEventListener js/document "mouseover" intercept-mouseover-event)

  (.addEventListener js/document "aut-logout-event"
                     (fn [e]
                       (.log js/console "aut-logout-event e:" e)
                       (login-events/logout)))



  ;; (.addEventListener js/document "touchstart" intercept-touchstart-event)
  ;; (.addEventListener js/document "touchend" intercept-touchend-event)
  ;; (.addEventListener js/document "touchcancel" intercept-touchcancel-event)

  ;; (.addEventListener js/document "long-touch-event" intercept-long-touch-event)




  ;; (go-loop []
  ;;   (let [[key ch] (alts! [touchstart-ch
  ;;                          touchend-ch
  ;;                          touchcancel-ch
  ;;                          (timeout 500)])]
  ;;     (condp = ch
  ;;       touchstart-ch (do
  ;;                       (reset! touch-event key)
  ;;                       (.log js/console "touchstart-ch" key)
  ;;                       (.log js/console "touchstart-ch" @touch-event))
  ;;       touchend-ch (do
  ;;                     (.log js/console "touchend-ch" key)
  ;;                     (.log js/console "touchend-ch" @touch-event)
  ;;                     (when (nil? @touch-event)
  ;;                       (println "PREVENTING DEFAULT ON touchend-ch (need to uncomment)")
  ;;                 ;; (.preventDefault key)
  ;;                 ;; (.stopPropagation key)
  ;;                       )
  ;;                     (reset! touch-event nil))
  ;;       touchcancel-ch (do
  ;;                        (.log js/console "touchcancel-ch" key)
  ;;                        (.log js/console "touchcancel-ch" @touch-event)
  ;;                       ;;  (reset! touch-event nil)
  ;;                        )
  ;;       (do
  ;;         (.log js/console "touch-timeout-ch" @touch-event)
  ;;         (when-not (nil? @touch-event)
  ;;           (.log js/console "touch-timeout-ch (.-target @touch-event)" (.-target @touch-event))
  ;;           ;; (.preventDefault @touch-event)
  ;;           ;; (.stopPropagation @touch-event)
  ;;           (.dispatchEvent
  ;;            js/document
  ;;            (new js/CustomEvent "long-touch-event" #js {:bubbles true, :composed true :detail @touch-event}))
  ;;           (reset! touch-event nil)))))
  ;;   (recur))


  (.addEventListener js/document "DOMContentLoaded"
                     (fn [event]
                       (routes/start!)
                       (re-frame/dispatch-sync [::events/initialize-db])

                       ;; Watchers must be registered before ::check-auth so that atom
                       ;; hydration from cookies (inside jwt-logged-in? / fbjwt-logged-in?)
                       ;; triggers the observers correctly.
                       (add-watch globals/fbjwt :fbjwt-observer
                                  (fn [_key _atom old-val new-val]
                                    (re-frame/dispatch [::login-events/fbjwt-changed old-val new-val])))

                       (add-watch globals/jwt :jwt-observer
                                  (fn [_key _atom old-val new-val]
                                    (re-frame/dispatch [::login-events/jwt-changed old-val new-val])))

                       ;; Validate JWT from atom/cookie, set [:auth :logged-in?] in db.
                       ;; dispatch-sync ensures auth state is set before first render.
                       (re-frame/dispatch-sync [::login-events/check-auth])

                       (sync-raid-len)
                       (sync-text-resizer)
                       (sync-theme)
                       (sync-dark-theme-depth)
                       (dev-setup)
                       (mount-root)
                       (attach-viewport-size-monitor)
                       (attach-scroll-event-listener))))
